import styled from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const BenefitsModalContentWrapper = styled.div`
  margin-top: 1rem;
  @media (min-width: ${breakpoints.sm}) {
    width: 75%;
  }
`;

export const ButtonWrapper = styled.div`
  margin: 1rem 0 0.5rem 0;
  display: flex;
  justify-content: center;
`;

export const SettingsWrapper = styled.a`
  margin-top: 0.5rem;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
  color: ${theme.palette.basic};
  &:hover {
    text-decoration: none;
  }
`;
